<template>
  <v-col md="9" sm="8" cols="12" class="px-1 py-0">
    <v-row class="ml-1 mt-1 mb-0">
      <v-col cols="12" md="6" lg="4" class="py-0 px-0">
        <v-checkbox
          class="mt-2"
          label="Hide Incumbents with no Basic Salary"
          v-model="hideNoBasicSalary"
          hide-details
          single-line
        >
        </v-checkbox>
      </v-col>
      <v-col cols="12" md="6" lg="4" class="py-0 px-0">
        <v-checkbox
          class="mt-2"
          label="Hide Incumbents reported in bands"
          v-model="hideReportedInBand"
          hide-details
          single-line
        >
        </v-checkbox>
      </v-col>
      <v-col cols="12" md="6" lg="4" class="py-0 px-0">
        <v-checkbox
          class="mt-2"
          label="Hide Pro-rated Incumbents"
          v-model="hideProrated"
          hide-details
          single-line
        >
        </v-checkbox>
      </v-col>
    </v-row>
    <v-row class="pl-3 pr-2">
      <v-tabs
        class="elevation-2"
        active-class="black--text"
        grow
        show-arrows
        background-color="secondary lighten-4"
        v-model="tab"
        ref="tabs"
      >
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab>
          Aggregate View
        </v-tab>
        <v-tab>
          Pay Mix
        </v-tab>
        <v-tab>
          Graph View
        </v-tab>
        <v-tab>
          Raw Data
        </v-tab>
      </v-tabs>
    </v-row>
    <v-row>
      <v-card
        class="my-1 ml-3 mr-2"
        :height="height - tabsHeight + 155 + 'px'"
        style="width:100%; overflow:auto"
      >
        <v-tabs-items v-model="tab" style="overflow:visible;">
          <v-tab-item>
            <!-- eslint-disable-next-line -->
            <CompensationTable
              :exchangeRate="currencySelected"
              :companyBenefits="adjustedBenefits"
              :loading="loading"
              :sectors="sectors"
              :onetJobGroups="onetJobGroups"
              :countries="countries"
              :jobClasses="jobClasses"
            >
            </CompensationTable>
          </v-tab-item>
          <v-tab-item>
            <PayMix
              :exchangeRate="currencySelected"
              :companyBenefits="adjustedBenefits"
              :height="height - tabsHeight + 155 + 'px'"
            >
            </PayMix>
          </v-tab-item>
          <v-tab-item>
            <!-- eslint-disable-next-line -->
            <ScatterPlot
              :exchangeRate="currencySelected"
              :companyBenefits="adjustedBenefits"
              :height="height - tabsHeight + 155 + 'px'"
              :companyOnHover="companyOnHover"
            >
            </ScatterPlot>
          </v-tab-item>
          <v-tab-item>
            <RawDataTable
              :exchangeRate="currencySelected"
              :companyBenefits="adjustedBenefits"
              :loading="loading"
              :compensationComponent="compensationComponent"
            ></RawDataTable>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-row>
  </v-col>
</template>
<script>
import Vue from 'vue';
import CompensationTable from './CompensationTable.vue';
import RawDataTable from './RawDataTable.vue';
import ScatterPlot from './ScatterPlot.vue';
import PayMix from './PayMix.vue';

export default Vue.extend({
  data() {
    return {
      tab: 0,
      tabsHeight: 122,
      hideNoBasicSalary: false,
      hideReportedInBand: false,
      hideProrated: false,
    };
  },
  computed: {
    adjustedBenefits() {
      const { filteredCompanyBenefits } = this;
      const out = filteredCompanyBenefits.map((c) => ({
        positions: c.positions
          .filter((pos) => pos.selected)
          .map((pos) => ({
            ...pos,
            rawTotalCashUSD: pos.totalCashUSD,
            rawTotalDirectCompensationUSD: pos.totalDirectCompensationUSD,
            shortTermIncentiveUSD: pos.totalCashUSD - pos.fixedCashUSD,
            longTermIncentiveUSD: pos.totalDirectCompensationUSD - pos.totalCashUSD,
            totalPerquisitesUSD: pos.totalRemunerationUSD - pos.totalDirectCompensationUSD,
            totalSocialBenefitsUSD: pos.totalCostUSD - pos.totalRemunerationUSD,
          })),
        company: c.company,
        revenue: c.revenue,
        profit: c.profit,
      }));
      return out;
    },
    filteredCompanyBenefits() {
      const { companiesSelected } = this;
      const out = this.companyBenefits
        .filter((cb) => companiesSelected.includes(cb.company))
        .map((c) => ({
          ...c,
          positions: c.positions.filter((pos) => {
            if (this.hideNoBasicSalary) {
              if (pos.salaryUSD === 0) {
                return false;
              }
            }
            if (this.hideReportedInBand) {
              if (!pos.isExact) {
                return false;
              }
            }
            if (this.hideProrated) {
              if (pos.prorate !== 12) {
                return false;
              }
            }
            return true;
          }),
        }));
      return out;
    },
  },
  props: {
    currencySelected: {
      type: Object,
      required: true,
    },
    companiesSelected: {
      type: Array,
      required: true,
    },
    companyBenefits: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
    },
    sectors: {
      type: Array,
    },
    onetJobGroups: {
      type: Array,
    },
    countries: {
      type: Array,
    },
    jobClasses: {
      type: Array,
    },
    companyOnHover: {
      type: String,
    },
    compensationComponent: {
      type: String,
    },
    height: {
      type: Number,
    },
  },
  mounted() {
    this.tabsHeight = this.$refs.tabs.$el.clientHeight;
  },
  components: {
    CompensationTable,
    PayMix,
    RawDataTable,
    ScatterPlot,
  },
});
</script>
<style scoped></style>
